import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TitlePages from "../../layout/TitlePages";
import Modal from "../../layout/Modal/Modal";
import { Link } from "react-router-dom";
import ListBadge from "../../layout/ListBadge";
import { dataReglamento, dataJuridico } from "../../data/dataTransparencia";
import DirectorioModal from "../../components/Directorio/DirectorioModal";
import "./Transparencia.css";
import Breadcrumbs from "../../layout/Breadcrumbs";
import Dropdown from "react-bootstrap/Dropdown";

/* ==========================================================================
   ÍCONOS PHOSPHOR EN PESO DUOTONE (#B5179B con opacidad nativa 0.2)
   viewBox 0 0 256 256 | fill: currentColor | aria-hidden="true"
   ========================================================================== */

/** 1. Obligaciones de Transparencia hasta marzo de 2026: Phosphor gavel (duotone) */
const IconGavelMarzo2026 = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M149.66,45.66l-64,64a8,8,0,0,1-11.32,0l-16-16a8,8,0,0,1,0-11.32l64-64a8,8,0,0,1,11.32,0l16,16A8,8,0,0,1,149.66,45.66Zm88,76.68-16-16a8,8,0,0,0-11.32,0l-64,64a8,8,0,0,0,0,11.32l16,16a8,8,0,0,0,11.32,0l64-64A8,8,0,0,0,237.66,122.34Z"
      opacity="0.2"
      className="transp-duo-bg"
    />
    <path d="M243.32,116.69l-16-16a16,16,0,0,0-20.84-1.53L156.84,49.52a16,16,0,0,0-1.52-20.84l-16-16a16,16,0,0,0-22.63,0l-64,64a16,16,0,0,0,0,22.63l16,16a16,16,0,0,0,20.83,1.52L96.69,124,31.31,189.38A25,25,0,0,0,66.63,224.7L132,159.32l7.17,7.16a16,16,0,0,0,1.52,20.84l16,16a16,16,0,0,0,22.63,0l64-64A16,16,0,0,0,243.32,116.69ZM80,104,64,88l64-64,16,16ZM55.32,213.38a9,9,0,0,1-12.69,0,9,9,0,0,1,0-12.68L108,135.32,120.69,148ZM101,105.66,145.66,61,195,110.34,150.35,155ZM168,192l-16-16,4-4h0l56-56h0l4-4,16,16Z" />
  </svg>
);

/** 2. Obligaciones de Transparencia a partir de abril 2026: Phosphor gavel con insignia arrow-circle-right */
const IconGavelAbril2026 = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <g transform="translate(0, 16) scale(0.86)">
      <path
        d="M149.66,45.66l-64,64a8,8,0,0,1-11.32,0l-16-16a8,8,0,0,1,0-11.32l64-64a8,8,0,0,1,11.32,0l16,16A8,8,0,0,1,149.66,45.66Zm88,76.68-16-16a8,8,0,0,0-11.32,0l-64,64a8,8,0,0,0,0,11.32l16,16a8,8,0,0,0,11.32,0l64-64A8,8,0,0,0,237.66,122.34Z"
        opacity="0.2"
        className="transp-duo-bg"
      />
      <path d="M243.32,116.69l-16-16a16,16,0,0,0-20.84-1.53L156.84,49.52a16,16,0,0,0-1.52-20.84l-16-16a16,16,0,0,0-22.63,0l-64,64a16,16,0,0,0,0,22.63l16,16a16,16,0,0,0,20.83,1.52L96.69,124,31.31,189.38A25,25,0,0,0,66.63,224.7L132,159.32l7.17,7.16a16,16,0,0,0,1.52,20.84l16,16a16,16,0,0,0,22.63,0l64-64A16,16,0,0,0,243.32,116.69ZM80,104,64,88l64-64,16,16ZM55.32,213.38a9,9,0,0,1-12.69,0,9,9,0,0,1,0-12.68L108,135.32,120.69,148ZM101,105.66,145.66,61,195,110.34,150.35,155ZM168,192l-16-16,4-4h0l56-56h0l4-4,16,16Z" />
    </g>
    {/* Insignia Phosphor arrow-circle-right en esquina superior derecha sin encimarse */}
    <g transform="translate(202, 50)">
      <circle cx="0" cy="0" r="46" className="transp-badge-bg" />
      <g transform="scale(0.38) translate(-128, -128)">
        <path
          d="M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z"
          opacity="0.2"
          className="transp-duo-bg"
        />
        <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm45.66-93.66a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32-11.32L148.69,136H88a8,8,0,0,1,0-16h60.69l-18.35-18.34a8,8,0,0,1,11.32-11.32Z" />
      </g>
    </g>
  </svg>
);

/** 3. Convenios: Phosphor handshake (duotone) */
const IconConvenios = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M200,152l-40,40L96,176,40,136,72.68,70.63,128,56l55.32,14.63L183.6,72H144L98.34,116.29a8,8,0,0,0,1.38,12.42C117.23,139.9,141,139.13,160,120Z"
      opacity="0.2"
      className="transp-duo-bg"
    />
    <path d="M254.3,107.91,228.78,56.85a16,16,0,0,0-21.47-7.15L182.44,62.13,130.05,48.27a8.14,8.14,0,0,0-4.1,0L73.56,62.13,48.69,49.7a16,16,0,0,0-21.47,7.15L1.7,107.9a16,16,0,0,0,7.15,21.47l27,13.51,55.49,39.63a8.06,8.06,0,0,0,2.71,1.25l64,16a8,8,0,0,0,7.6-2.1l55.07-55.08,26.42-13.21a16,16,0,0,0,7.15-21.46Zm-54.89,33.37L165,113.72a8,8,0,0,0-10.68.61C136.51,132.27,116.66,130,104,122L147.24,80h31.81l27.21,54.41ZM41.53,64,62,74.22,36.43,125.27,16,115.06Zm116,119.13L99.42,168.61l-49.2-35.14,28-56L128,64.28l9.8,2.59-45,43.68-.08.09a16,16,0,0,0,2.72,24.81c20.56,13.13,45.37,11,64.91-5L188,152.66Zm62-57.87-25.52-51L214.47,64,240,115.06Zm-87.75,92.67a8,8,0,0,1-7.75,6.06,8.13,8.13,0,0,1-1.95-.24L80.41,213.33a7.89,7.89,0,0,1-2.71-1.25L51.35,193.26a8,8,0,0,1,9.3-13l25.11,17.94L126,208.24A8,8,0,0,1,131.82,217.94Z" />
  </svg>
);

/** 4. Directorio General: Phosphor phone-call (duotone) */
const IconDirectorio = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M215.94,182.08A48.33,48.33,0,0,1,168,224,136,136,0,0,1,32,88,48.33,48.33,0,0,1,73.92,40.06a8,8,0,0,1,8.3,4.8l21.13,47.2a8,8,0,0,1-.66,7.53L81.32,125a7.93,7.93,0,0,0-.54,7.81c8.27,16.93,25.77,34.22,42.75,42.41a7.92,7.92,0,0,0,7.83-.59l25-21.3a8,8,0,0,1,7.59-.69l47.16,21.13A8,8,0,0,1,215.94,182.08Z"
      opacity="0.2"
      className="transp-duo-bg"
    />
    <path d="M144.27,45.93a8,8,0,0,1,9.8-5.66,86.22,86.22,0,0,1,61.66,61.66,8,8,0,0,1-5.66,9.8A8.23,8.23,0,0,1,208,112a8,8,0,0,1-7.73-5.94,70.35,70.35,0,0,0-50.33-50.33A8,8,0,0,1,144.27,45.93Zm-2.33,41.8c13.79,3.68,22.65,12.54,26.33,26.33A8,8,0,0,0,176,120a8.23,8.23,0,0,0,2.07-.27,8,8,0,0,0,5.66-9.8c-5.12-19.16-18.5-32.54-37.66-37.66a8,8,0,1,0-4.13,15.46Zm81.94,95.35A56.26,56.26,0,0,1,168,232C88.6,232,24,167.4,24,88A56.26,56.26,0,0,1,72.92,32.12a16,16,0,0,1,16.62,9.52l21.12,47.15,0,.12A16,16,0,0,1,109.39,104c-.18.27-.37.52-.57.77L88,129.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,223.88,183.08Zm-15.88-2s-.07,0-.11,0h0l-47-21.05-24.35,20.71a8.44,8.44,0,0,1-.74.56,16,16,0,0,1-15.75,1.14c-18.73-9.05-37.4-27.58-46.46-46.11a16,16,0,0,1,1-15.7,6.13,6.13,0,0,1,.57-.77L96,95.15l-21-47a.61.61,0,0,1,0-.12A40.2,40.2,0,0,0,40,88,128.14,128.14,0,0,0,168,216,40.21,40.21,0,0,0,208,181.07Z" />
  </svg>
);

/** 5. Informes anuales: Phosphor chart-bar (duotone) */
const IconInformes = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M208,40V208H152V40Z"
      opacity="0.2"
      className="transp-duo-bg"
    />
    <path d="M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z" />
  </svg>
);

/** 6. Aviso de privacidad: Phosphor lock-key (duotone) */
const IconPrivacidad = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M208,88H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V96A8,8,0,0,0,208,88Zm-80,72a20,20,0,1,1,20-20A20,20,0,0,1,128,160Z"
      opacity="0.2"
      className="transp-duo-bg"
    />
    <path d="M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Zm-80-96a28,28,0,0,0-8,54.83V184a8,8,0,0,0,16,0V166.83A28,28,0,0,0,128,112Zm0,40a12,12,0,1,1,12-12A12,12,0,0,1,128,152Z" />
  </svg>
);

/** 7. Presentar solicitud: Phosphor note-pencil (duotone) */
const IconSolicitud = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M200,88l-72,72H96V128l72-72Z"
      opacity="0.2"
      className="transp-duo-bg"
    />
    <path d="M229.66,58.34l-32-32a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,88,128v32a8,8,0,0,0,8,8h32a8,8,0,0,0,5.66-2.34l96-96A8,8,0,0,0,229.66,58.34ZM124.69,152H104V131.31l64-64L188.69,88ZM200,76.69,179.31,56,192,43.31,212.69,64ZM224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Z" />
  </svg>
);

/** 8. Programas Operativos Anuales (POA): Phosphor calendar-check (duotone) */
const IconPOA = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M216,48V88H40V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z"
      opacity="0.2"
      className="transp-duo-bg"
    />
    <path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-38.34-85.66a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L116,164.69l42.34-42.35A8,8,0,0,1,169.66,122.34Z" />
  </svg>
);

/** 9. Información Contable y Financiera: Phosphor calculator (duotone) */
const IconContable = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M176,64v48H80V64Z"
      opacity="0.2"
      className="transp-duo-bg"
    />
    <path d="M80,120h96a8,8,0,0,0,8-8V64a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8v48A8,8,0,0,0,80,120Zm8-48h80v32H88ZM200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm0,192H56V40H200ZM100,148a12,12,0,1,1-12-12A12,12,0,0,1,100,148Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,140,148Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,180,148Zm-80,40a12,12,0,1,1-12-12A12,12,0,0,1,100,188Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,140,188Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,180,188Z" />
  </svg>
);

/** 10. Planes de Trabajo: Phosphor list-checks (duotone) */
const IconPlanes = () => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M216,64V192H128V64Z"
      opacity="0.2"
      className="transp-duo-bg"
    />
    <path d="M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM82.34,42.34,56,68.69,45.66,58.34A8,8,0,0,0,34.34,69.66l16,16a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,82.34,42.34Zm0,64L56,132.69,45.66,122.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm0,64L56,196.69,45.66,186.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z" />
  </svg>
);

/** Indicador de enlace: flecha diagonal superior derecha (14px) */
const ArrowDiagonal = () => (
  <span className="transp-card-arrow" aria-hidden="true">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
    >
      <line x1="7" y1="17" x2="17" y2="7" />
      <polyline points="7 7 17 7 17 17" />
    </svg>
  </span>
);

/** Indicador de desplegable: chevron hacia abajo (16px) */
const ChevronDown = () => (
  <span className="transp-card-chevron" aria-hidden="true">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      preserveAspectRatio="xMidYMid meet"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  </span>
);

/** Indicador de cierre: chevron hacia arriba (16px) */
const ChevronUp = () => (
  <span className="transp-card-chevron transp-card-chevron-up" aria-hidden="true">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      preserveAspectRatio="xMidYMid meet"
    >
      <polyline points="18 15 12 9 6 15" />
    </svg>
  </span>
);

/** Componente de Tarjeta de Opción (Lista semántica li) */
const TransparenciaItem = ({ to, href, icon, text, onClick }) => {
  const innerContent = (
    <>
      <div className="transp-icon-circle" aria-hidden="true" focusable="false">
        {icon}
      </div>
      <span className="transp-card-title">{text}</span>
      <ArrowDiagonal />
    </>
  );

  if (to) {
    return (
      <li className="transp-card-item">
        <Link to={to} className="transp-card-link">
          {innerContent}
        </Link>
      </li>
    );
  }
  if (href) {
    return (
      <li className="transp-card-item">
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className="transp-card-link"
        >
          {innerContent}
        </a>
      </li>
    );
  }
  return (
    <li className="transp-card-item">
      <button
        type="button"
        onClick={onClick}
        className="transp-card-link transp-card-btn"
      >
        {innerContent}
      </button>
    </li>
  );
};

const Transparencia = () => {
  const [directorioOpen, setDirectorioOpen] = useState(false);
  const [openMarzo, setOpenMarzo] = useState(false);
  const [openAbril, setOpenAbril] = useState(false);

  useEffect(() => {
    document.title = `Transparencia`;
  }, []);

  return (
    <>
      <Breadcrumbs path={[{ label: "Transparencia" }]} />
      <TitlePages variant="banner" title="Transparencia" subTitle="" />

      {/* Sección principal de opciones con estilo formal y elegante */}
      <section
        className="transp-options-section"
        aria-label="Opciones de Transparencia"
      >
        <div className="transp-container">
          <ul className="transp-cards-grid">
            {/* 1. Obligaciones hasta marzo de 2026 */}
            <li className="transp-card-item">
              <Dropdown
                className="w-100 h-100 transp-dropdown-container"
                show={openMarzo}
                onToggle={(nextShow) => setOpenMarzo(nextShow)}
              >
                <Dropdown.Toggle
                  variant="light"
                  className="transp-card-link transp-card-btn transp-dropdown-toggle p-0 border-0 bg-transparent"
                  id="dropdown-obligaciones-marzo"
                >
                  <div className="transp-icon-circle" aria-hidden="true" focusable="false">
                    <IconGavelMarzo2026 />
                  </div>
                  <span className="transp-card-title">
                    Obligaciones de Transparencia <br />hasta marzo de 2026
                  </span>
                  <ChevronDown />
                </Dropdown.Toggle>

                <Dropdown.Menu renderMenuOnMount className="transp-dropdown-menu text-center">
                  <div className="transp-menu-header">
                    Obligaciones de Transparencia <br />hasta marzo de 2026
                  </div>
                  <div className="transp-menu-items">
                    <Dropdown.Item as={Link} to="/Articulo63" className="transp-menu-item">
                      Art. 63 Obligaciones Comunes
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/Articulo67" className="transp-menu-item">
                      Art. 67 Obligaciones Específicas
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/Articulo94" className="transp-menu-item">
                      Art. 94 Obligaciones Específicas
                    </Dropdown.Item>
                  </div>
                  <button
                    type="button"
                    className="transp-menu-chevron-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenMarzo(false);
                    }}
                    aria-label="Cerrar opciones"
                  >
                    <ChevronUp />
                  </button>
                </Dropdown.Menu>
              </Dropdown>
            </li>

            {/* 2. Obligaciones a partir de abril 2026 */}
            <li className="transp-card-item">
              <Dropdown
                className="w-100 h-100 transp-dropdown-container"
                show={openAbril}
                onToggle={(nextShow) => setOpenAbril(nextShow)}
              >
                <Dropdown.Toggle
                  variant="light"
                  className="transp-card-link transp-card-btn transp-dropdown-toggle p-0 border-0 bg-transparent"
                  id="dropdown-obligaciones-abril"
                >
                  <div className="transp-icon-circle" aria-hidden="true" focusable="false">
                    <IconGavelAbril2026 />
                  </div>
                  <span className="transp-card-title">
                    Obligaciones de Transparencia <br />a partir de abril 2026
                  </span>
                  <ChevronDown />
                </Dropdown.Toggle>

                <Dropdown.Menu renderMenuOnMount className="transp-dropdown-menu text-center">
                  <div className="transp-menu-header">
                    Obligaciones de Transparencia <br />a partir de abril 2026
                  </div>
                  <div className="transp-menu-items">
                    <Dropdown.Item as={Link} to="/ObligacionesC" className="transp-menu-item">
                      Obligaciones de Transparencia Comunes
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/ObligacionesE" className="transp-menu-item">
                      Obligaciones de Transparencia Específicas
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/TablaA" className="transp-menu-item">
                      Tabla de aplicabilidad de Obligaciones de Transparencia
                    </Dropdown.Item>
                  </div>
                  <button
                    type="button"
                    className="transp-menu-chevron-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenAbril(false);
                    }}
                    aria-label="Cerrar opciones"
                  >
                    <ChevronUp />
                  </button>
                </Dropdown.Menu>
              </Dropdown>
            </li>

            {/* 3. Convenios */}
            <TransparenciaItem
              to="/Convenios"
              icon={<IconConvenios />}
              text="Convenios"
            />

            {/* 4. Directorio General */}
            <TransparenciaItem
              onClick={() => setDirectorioOpen(true)}
              icon={<IconDirectorio />}
              text="Directorio General"
            />

            {/* 5. Informes anuales */}
            <TransparenciaItem
              to="/InformesAnuales"
              icon={<IconInformes />}
              text="Informes anuales"
            />

            {/* 6. Aviso de privacidad */}
            <TransparenciaItem
              to="/AvisosPrivacidad"
              icon={<IconPrivacidad />}
              text="Aviso de privacidad"
            />

            {/* 7. Presentar solicitud */}
            <TransparenciaItem
              to="/FormatoSolicitud"
              icon={<IconSolicitud />}
              text="Presentar solicitud"
            />

            {/* 8. Programas Operativos Anuales */}
            <TransparenciaItem
              to="/POA"
              icon={<IconPOA />}
              text="Programas Operativos Anuales"
            />

            {/* 9. Información Contable y Financiera */}
            <TransparenciaItem
              to="/InformacionContable"
              icon={<IconContable />}
              text="Información Contable y Financiera"
            />

            {/* 10. Planes de Trabajo */}
            <TransparenciaItem
              to="/Section"
              icon={<IconPlanes />}
              text="Planes de Trabajo"
            />
          </ul>
        </div>
      </section>

      {/* --- resto de tu código igual --- */}
      <div className="w-100 Transparencia__header mt-5 mb-5">
        <a
          href="https://www.plataformadetransparencia.org.mx/web/guest/inicio"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="img-fluid"
            src="https://itetlax.org.mx/assets/img/icons/pnt.png"
            alt="Plataforma Nacional de Transparencia"
          />
        </a>
        <a
          href="http://consultapublicamx.inai.org.mx:8080/vut-web/?idSujetoObigadoParametro=5387&idEntidadParametro=29&idSectorParametro=24"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="img-fluid"
            src="https://itetlax.org.mx/assets/img/icons/ot.png"
            alt="Obligaciones de Transparencia"
          />
        </a>
      </div>

      <Modal
        idModal="modalReglamento"
        titleModal="Reglamento Interior ITE"
        sizeModal=""
        contentModal={
          <ListBadge ifNumbered={""} listsBadgeItem={dataReglamento} />
        }
      />

      <div className="margin-bottom-2">
        <Modal
          idModal="modalJuridico"
          titleModal="Información Jurídica"
          sizeModal=""
          contentModal={
            <ListBadge ifNumbered={""} listsBadgeItem={dataJuridico} />
          }
        />
      </div>

      <DirectorioModal
        isOpen={directorioOpen}
        onClose={() => setDirectorioOpen(false)}
      />
    </>
  );
};

export default Transparencia;

TransparenciaItem.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
